import * as React from 'react';
import { BarChart } from '@mui/x-charts/BarChart';
import { Typography, Box, Stack } from '@mui/material';
import { useTheme } from '@emotion/react';

export default function BillChart({ data }) {
  const theme = useTheme();
  const legendItems = [
    { label: 'Do nothing', color: '#c2c9d6' },
    { label: 'Postpaid and Buy', color: theme.palette.secondary.light },
  ];
  const colors = theme.palette.customColors;
  if (!data) return null;
  const safeNumber = (value) => value ?? 0;
  const chartData = [
    {
      label: `Do nothing (₹${safeNumber(data?.do_nothing?.total_energy_expense)})`,
      Name: safeNumber(data?.do_nothing?.total_energy_expense),
    },
    {
      label: `Postpaid (₹${safeNumber(data?.lease?.total_energy_expense)})`,
      Name: safeNumber(data?.lease?.total_energy_expense),
    },
    {
      label: `Buy (₹${safeNumber(data?.own?.total_energy_expense) >= 0 ? safeNumber(data?.own?.total_energy_expense) : 0})`,
      Name:
        safeNumber(data?.own?.total_energy_expense) >= 0
          ? safeNumber(data?.own?.total_energy_expense)
          : 0,
    },
  ];
  const newTableData = {
    1: { value: 9 },
    2: { value: 10 },
    3: { value: 10 },
  };
  const valuesArray = Object.values(newTableData).map((item) => item.value);
  const minVal = Math.min(...valuesArray);
  const maxVal = Math.max(...valuesArray);
  const barColors = valuesArray.map((val) =>
    val === minVal
      ? '#c2c9d6'
      : val === maxVal
        ? theme.palette.secondary.light
        : null,
  );
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 4,
        my: 6,
        flexWrap: 'wrap',
      }}
    >
      {/* Chart */}
      <Box sx={{ flex: '1 1 600px' }}>
        <BarChart
          dataset={chartData}
          xAxis={[
            {
              scaleType: 'band',
              dataKey: 'label',
              colorMap: {
                type: 'ordinal',
                colors: barColors,
              },
              valueFormatter: (value) => {
                const [label, amount] = value.split('(');
                return `${label}\n(${amount}`;
              },
              height: 90,
            },
          ]}
          sx={{
            '& .MuiChartsAxis-root.MuiChartsAxis-directionY .MuiChartsAxis-line':
              {
                display: 'none',
              },
            '& .MuiChartsAxis-root.MuiChartsAxis-directionY .MuiChartsAxis-tick':
              {
                display: 'none',
              },
            '& .MuiChartsAxis-root.MuiChartsAxis-directionY .MuiChartsAxis-tickLabel':
              {
                fontWeight: 600,
                fill: 'gray',
              },
            '& .MuiChartsAxis-root.MuiChartsAxis-directionX .MuiChartsAxis-tickLabel':
              {
                fontWeight: 600,
              },
          }}
          series={[
            {
              dataKey: 'Name',
              stack: 'Name',
              color: theme.palette.secondary.light,
            },
          ]}
          borderRadius={10}
          width={500}
          height={400}
          margin={{ top: 30, bottom: 40, right: 10, left: 70 }}
          grid={{ vertical: false, horizontal: false }}
          legend={{ hidden: true }}
          groupPadding={0.3}
          barCategoryGap={40}
        />
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'flex-start',
        }}
      >
        <Box mb={6}>
          <Typography variant='h6' color='text.secondary' fontWeight={600}>
            start today with postpaid plans
          </Typography>
          <Typography
            variant='h2'
            fontWeight='bold'
            mt={1}
            color={theme.palette.secondary.light}
          >
            {Math.floor(
              safeNumber(
                1 -
                  data?.lease.total_energy_expense /
                    data?.do_nothing.total_energy_expense,
              ) * 100,
            )}
            % savings
          </Typography>
        </Box>

        <Box>
          <Typography variant='h6' color='text.secondary' fontWeight={600}>
            once convinced, buy to get
          </Typography>
          <Typography
            variant='h2'
            fontWeight='bold'
            mt={1}
            color={theme.palette.secondary.light}
          >
            {Math.floor(
              (safeNumber(data?.own.total_energy_expense) /
                data?.do_nothing.total_energy_expense) *
                100,
            ) >= 0
              ? Math.floor(
                  safeNumber(
                    1 -
                      data?.own.total_energy_expense /
                        data?.do_nothing.total_energy_expense,
                  ) * 100,
                )
              : 100}
            % savings
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
